import { render, staticRenderFns } from "./MemberAddress.vue?vue&type=template&id=af03f768&scoped=true"
import script from "./MemberAddress.vue?vue&type=script&lang=js"
export * from "./MemberAddress.vue?vue&type=script&lang=js"
import style0 from "./MemberAddress.vue?vue&type=style&index=0&id=af03f768&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af03f768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af03f768')) {
      api.createRecord('af03f768', component.options)
    } else {
      api.reload('af03f768', component.options)
    }
    module.hot.accept("./MemberAddress.vue?vue&type=template&id=af03f768&scoped=true", function () {
      api.rerender('af03f768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/MemberAddress.vue"
export default component.exports